<template>
        <div>
            <v-client-table :columns="columns" :data="tableData" :options="options">
</v-client-table> 
        </div>
</template>

<script>
import moment from 'moment'
export default {
props:{
      Data:'',
    },
     data: function(){
        return {
            Patient:null,
            AppName: 'Dental Application',
            AppIcon: 'fas fa-tooth',
            HSN:'',
            showModal:false,
            isValid:false,
            Access:'',
            NoteType:'',
            AllowAdd:false,
            showEditModal:false,
            isValid:'',
  
            Button:'',
        columns: ['residencycode','residencystatus','effectivedate','expirydate'],
        tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Name',
              filter:"Search Residency Information Data:",
              limit:"Records:",
              page:"Page:",
              filter:"",
              filterPlaceholder:"Search Residency History",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
           effectivedate(h, row){
              return moment(row.residencyeffectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            expirydate(h, row) {
              return moment(row.residencyexpirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            }
            },

          headings: {
            residencycode: 'Residency Code',
            residencystatus: 'Status',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            lastUpdatedby: 'Update Date',
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['residencycode','residencystatus','residencyeffectivedate','residencyexpirydate'],
         filterable: ['residencycode','residencystatus','residencyeffectivedate','residencyexpirydate'], 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
        
        },
        created:function(){
            
            this.tableData = this.Data;
        }
}
</script>

<style>

</style>
